// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data embedded as JSON in the section
    const product = JSON.parse(section.querySelector(".productV20JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file
    let activeVariant = JSON.parse(section.querySelector(".productV20VariantJSON").textContent);

    // map of variant id to its maltertech.ongoing_price metafield (dollars, null when unset)
    const variantIDtoOngoingPrice = JSON.parse(section.querySelector(".productV20VariantIDtoOngoingPriceJSON").textContent);

    // map of variant id to its custom.dosage_with_text metafield, the same per dose copy the selling card shows
    const variantIDtoDose = JSON.parse(section.querySelector(".productV20VariantIDtoDoseJSON").textContent);

    /************
     Product Swiper
     ************/

    let thumbs = new Swiper(section.querySelector(".productV20VisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 4
    });

    // setup product swiper
    const productV20Swiper = new Swiper(section.querySelector(".productV20VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: section.querySelector('.productV20VisualSwiperNext'),
            prevEl: section.querySelector('.productV20VisualSwiperPrev'),
        },
        thumbs: {
            swiper: thumbs
        },
        on: {
            slideChange: function () {
                // pause all videos
                section.querySelectorAll(".productV20VisualSwiperSlide video")?.forEach(element => {
                    element.pause();
                });
            }
        }
    });


    // play video on slide play click
    section.querySelectorAll(".productV20VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV20VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV20VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // setup Dropdowns
    section.querySelectorAll(".productV20InfoDropdownTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /****************
     * Product Quantity
     */

    let quantity = 1;


    /**************
     Product ATC
     ***************/

    section.querySelector(".productV20ATC").addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productV20SellingLabelInput.sub')?.checked) {
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
            let activeVariantPlan = skioAllocs(activeVariant, product)[0];
            // skio:filter:end
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: for (let plan of activeVariant.selling_plan_allocations) {
            for (let plan of skioAllocs(activeVariant, product)) {
            // skio:filter:end
                if (plan.selling_plan_id === parseInt(section.querySelector('.productV20SellingLabelBodyBottomWrapContentSelect').value)) {
                    activeVariantPlan = plan;
                }
            }
            formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });


    // font fix override for shopify payments (make b element normal weight)
    document.addEventListener("DOMContentLoaded", async function () {
        customElements.whenDefined("shopify-payment-terms").then(() => {
            customElements.whenDefined("shop-pay-installments-banner").then(() => {
                // the element is absent on products without installments, so bail out rather than throw
                const bannerBold = section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
                if (!bannerBold) {
                    return;
                }
                bannerBold.style = "font-weight: 400;";
            });
        });
    });

    /************
     Selling UI (folded from shared product-main.js + product-js.js, section-scoped)
     ************/

    // initialize the custom selling-plan select dropdown
    function initializeCustomSelect() {
        const selectElement = section.querySelector(".productV20SellingLabelBodyBottomWrapContentSelect");
        const detailsElement = section.querySelector(".customDetails");
        if (!selectElement || !detailsElement) {
            return;
        }

        const summaryElement = detailsElement.querySelector(".customDetailsTitle");
        const optionElements = detailsElement.querySelectorAll(".customOption");

        // sync the visible summary to the native select's current value
        const initialOption = selectElement.options[selectElement.selectedIndex];
        const initialValue = initialOption ? initialOption.value : "";
        if (summaryElement) {
            summaryElement.firstElementChild.textContent = initialOption ? initialOption.textContent : "";
        }

        optionElements.forEach((option, index) => {
            const value = selectElement.options[index]?.value || "";
            option.setAttribute("data-value", value);
            option.classList.toggle("selected", value === initialValue);
        });

        // clicking a custom option writes back to the native select
        optionElements.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const text = option.textContent.trim();
                selectElement.value = value;
                if (summaryElement) {
                    summaryElement.firstElementChild.textContent = text;
                }
                optionElements.forEach((opt) => opt.classList.remove("selected"));
                option.classList.add("selected");
                detailsElement.removeAttribute("open");
            });
        });
    }

    // refresh the SAVE badges from the active variant pricing
    function updateSavingsDisplay() {
        if (!activeVariant) {
            return;
        }
        const subSaveElement = section.querySelector(".productV20SellingTagDiscountSub");
        const oneTimeSaveElement = section.querySelector(".productV20SellingTagDiscountOne");
        if (!subSaveElement) {
            return;
        }
        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) {
            return;
        }
        const subTotal = activeVariant.compare_at_price ? activeVariant.compare_at_price - sellingPlanPrice : activeVariant.price - sellingPlanPrice;
        const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;
        subSaveElement.innerHTML = `SAVE ${price(subTotal, true)}`;
        if (oneTimeSaveElement) {
            if (oneTimeTotal > 0) {
                oneTimeSaveElement.innerHTML = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSaveElement.classList.remove("hidden");
            } else {
                oneTimeSaveElement.classList.add("hidden");
            }
        }

        // discount percentage off the base price (compare-at when present, otherwise regular price)
        const basePrice = activeVariant.compare_at_price || activeVariant.price;
        const discountPercent = Math.round((basePrice - sellingPlanPrice) / basePrice * 100);

        // ongoing price comes from the variant's maltertech.ongoing_price metafield (dollars), fall back to the selling plan price
        let ongoingPrice = sellingPlanPrice;
        const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
        if (ongoingPriceMetafield != null) {
            ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
        }
        const ongoingPercent = Math.round((basePrice - ongoingPrice) / basePrice * 100);

        // update bullet price - ongoing price per month plus the ongoing discount percentage
        const bulletSaveElement = section.querySelector(".productV20SellingLabelBodyBottomWrapContentBulletsItemSave");
        if (bulletSaveElement) {
            bulletSaveElement.innerHTML = `
                <span class="productV20SellingLabelBodyBottomWrapContentBulletsItemSavePrice">${price(ongoingPrice, true)}/mo after first order</span>
                <span class="productV20SellingLabelBodyBottomWrapContentBulletsItemSaveOngoing">(${ongoingPercent}% OFF ongoing)</span>
            `;
        }
    }

    // hide the one-time bottom block when it has no text
    function checkOneTimeTextVisibility() {
        const textElement = section.querySelector(".productV20SellingLabelBodyBottomWrapContentTxt");
        const bottomContentElement = section.querySelector(".productV20SellingLabelBody.once .productV20SellingLabelBodyBottom");
        if (!textElement || !bottomContentElement) {
            return;
        }
        bottomContentElement.classList.toggle("hidden", textElement.textContent.trim() === "");
    }

    // swap dosage text when a dosage option is clicked (folded from product-js.js)
    section.querySelectorAll("[data-dosage-click]").forEach((dosageOption) => {
        dosageOption.addEventListener("click", function () {
            const subItem = section.querySelector(".productV20SellingLabelBodyTopLeftDosageText");
            const oneTimeItem = section.querySelector(".productV20SellingLabelBodyTopLeftDosageText.oneTime");
            if (subItem) {
                subItem.innerHTML = dosageOption.getAttribute("data-dosage-sub");
            }
            if (oneTimeItem) {
                oneTimeItem.innerHTML = dosageOption.getAttribute("data-dosage-one-time");
            }
        });
    });

    // find the master selling plan object for a given allocation id
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }

    // build the native select AND the visible custom dropdown from the active variant's selling plans
    function populateSellingPlans() {
        // skio:filter:start
        // was: const allocations = activeVariant?.selling_plan_allocations || [];
        const allocations = skioAllocs(activeVariant, product) || [];
        // skio:filter:end
        let optionsHTML = "";
        let customHTML = "";
        let first = true;
        allocations.forEach(allocation => {
            // skip the starter-kit selling plan group
            if (allocation.selling_plan_group_id === "91e7beddcc2b25a88da97e3b201deec8db7b43bb") {
                return;
            }
            const sellingPlan = getSellingPlanById(allocation.selling_plan_id);
            if (!sellingPlan) {
                return;
            }
            optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
            customHTML += `<button type="button" class="customOption${first ? " selected" : ""}" data-value="${sellingPlan.id}">${sellingPlan.name}</button>`;
            first = false;
        });
        // only overwrite the Liquid-rendered options if we actually built some
        if (!optionsHTML) {
            return;
        }
        section.querySelectorAll(".productV20SellingLabelBodyBottomWrapContentSelect").forEach(select => {
            select.innerHTML = optionsHTML;
        });
        // mirror the same plans into the visible custom dropdown (Liquid renders these empty for this product)
        const customOptions = section.querySelector(".customOptions");
        if (customOptions) {
            customOptions.innerHTML = customHTML;
        }
    }

    // re-run the selling UI on load and on every product update
    function refreshSellingUI() {
        populateSellingPlans();
        initializeCustomSelect();
        updateSavingsDisplay();
        checkOneTimeTextVisibility();
    }

    section.addEventListener("mainProduct:update", refreshSellingUI);
    refreshSellingUI();


    /**************
     Product Sticky Bar (Mobile)
     ***************/

    // the sticky bar renders outside the section element, so match it on this section's id
    const productV20Sticky = document.querySelector(`.productV20Sticky[data-product-sticky="${sectionID}"]`);
    if (productV20Sticky) {
        const productV20ATCEl = section.querySelector(".productV20ATC");
        const productV20StickySubInput = productV20Sticky.querySelector('.productV20StickyTopLeftBodyOptionsLabelInput[value="sub"]');
        const productV20StickyDose = productV20Sticky.querySelector(".productV20StickyBottomDose");
        const productV20StickyPrice = productV20Sticky.querySelector(".productV20StickyBottomPrice");
        const productV20StickyATC = productV20Sticky.querySelector(".productV20StickyTopATC");

        // several product sections can share a page, only the first bar whose section is rendered may show
        function ownsSticky() {
            const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
                const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
                return barSection && barSection.offsetParent !== null;
            });
            return owner != null && owner.dataset.productSticky === sectionID;
        }

        // show the sticky bar whenever the main ATC isn't in the viewport (above or below)
        function toggleStickyVisibility() {
            const rect = productV20ATCEl.getBoundingClientRect();
            const inView = rect.bottom > 0 && rect.top < window.innerHeight;
            productV20Sticky.classList.toggle("visible", !inView && ownsSticky());
        }

        window.addEventListener("scroll", toggleStickyVisibility, {passive: true});
        toggleStickyVisibility();

        // sync the sticky bar choice into the main selling radio so the rest of the page updates
        productV20Sticky.querySelectorAll(".productV20StickyTopLeftBodyOptionsLabelInput").forEach(input => {
            input.addEventListener("change", function () {
                const mainInput = section.querySelector(`.productV20SellingLabelInput.${this.value}`);
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event("change", {bubbles: true}));
                }
                updateProductSticky();
            });
        });

        // sticky ATC reuses the same add-to-cart flow as the main button
        productV20StickyATC.addEventListener("click", function () {
            productV20ATCEl.click();
        });

        // refresh dose visibility and price text from current variant + selling state
        function updateProductSticky() {
            const subChecked = productV20StickySubInput.checked;

            // dose price comes from the active variant's dosage metafield, hidden when it has no price
            const dosePrice = (variantIDtoDose[activeVariant.id] || "").match(/\$\d+(\.\d+)?/);
            productV20StickyDose.textContent = dosePrice ? `${dosePrice[0]}/dose` : "";

            // dose only shows for subscription
            productV20StickyDose.classList.toggle("active", subChecked && dosePrice != null);

            // price text differs by selling type
            if (subChecked) {
                // skio:filter:start
                // was: const subPrice = price(activeVariant.selling_plan_allocations[0].price * quantity, true);
                const subPrice = price(skioAllocs(activeVariant, product)[0].price * quantity, true);
                // skio:filter:end

                // ongoing price comes from the variant's maltertech.ongoing_price metafield, fall back to the selling plan price
                // skio:filter:start
                // was: let ongoingPrice = activeVariant.selling_plan_allocations[0].price;
                let ongoingPrice = skioAllocs(activeVariant, product)[0].price;
                // skio:filter:end
                const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
                if (ongoingPriceMetafield != null) {
                    ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
                }

                productV20StickyPrice.innerHTML = `<strong>${subPrice} </strong>+ FREE shipping* - <em>${price(ongoingPrice, true)}/mo after, cancel anytime</em>`;
            } else {
                const oncePrice = price(activeVariant.price * quantity, true);
                productV20StickyPrice.innerHTML = `<strong>${oncePrice}</strong> + $9.99 shipping*`;
            }
        }

        // re-render whenever the main product update event fires
        section.addEventListener("mainProduct:update", updateProductSticky);
        updateProductSticky();
    }

}());
